package com.cybersoftsolution.cybersoftsolutionweb.utils

import com.varabyte.kobweb.compose.ui.graphics.Colors
import kotlinx.coroutines.delay
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.datetime.internal.JSJoda.DateTimeFormatter
import kotlinx.datetime.internal.JSJoda.ZoneId
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.hsl
import org.jetbrains.compose.web.css.hsla
import org.jetbrains.compose.web.css.percent

import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import kotlin.js.Date


object Utils {


    fun String.decodeURIComponent(): String {
        val sb = StringBuilder()
        var i = 0
        while (i < this.length) {
            val c = this[i]
            when (c) {
//                '+' -> sb.append(' ') // Los '+' se decodifican como espacios
                '%' -> {
                    if (i + 2 < this.length) {
                        try {
                            val hex = this.substring(i + 1, i + 3)
                            val code = hex.toInt(16)
                            sb.append(code.toChar())
                            i += 2
                        } catch (e: NumberFormatException) {
                            // Si no es un código hexadecimal válido, se añade el '%' tal cual
                            sb.append(c)
                        }
                    } else {
                        sb.append(c)
                    }
                }
                else -> sb.append(c)
            }
            i++
        }
        return sb.toString()
    }

    fun isDevelopmentMode(): Boolean {
        val nodeEnv = js("process.env.NODE_ENV").unsafeCast<String?>()
        return nodeEnv == "development"
    }

    fun CSSColorValue.darker(factor: Float = 0.9f): CSSColorValue {
        require(factor in 0f..1f) { "Factor debe estar entre 0 y 1" }

        return when (this) {
            is Color.RGB -> {
                val red = (this.r.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                val green = (this.g.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                val blue = (this.b.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                rgb(red, green, blue) // Corrección: usar rgb()
            }
            is Color.RGBA -> {
                val red = (this.r.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                val green = (this.g.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                val blue = (this.b.toInt() * (1 - factor)).toInt().coerceIn(0, 255)
                rgba(red, green, blue, this.a) // Corrección: usar rgba()
            }
            is Color.HSL -> {
                hsl(this.h, this.s, (this.l.toFloat() * (1 - factor)).coerceIn(0F, 100F)) // Corrección: usar hsl()
            }
            is Color.HSLA -> {
                hsla(this.h, this.s, (this.l.toInt().toFloat() * (1 - factor)).coerceIn(0F, 100F), this.a) // Corrección: usar hsla()
            }
            else -> {
                println("Tipo de color no soportado para oscurecer: $this")
                this
            }
        }
    }

    suspend fun showTemporaryTextMessage(newValue: String, block: suspend (String) -> Unit) {
        block(newValue) // Executes the code block with the modified variable
        delay(3000) // Waits for 3 seconds
        block(" ") // Restores the variable to an empty string
    }

    fun getLocalDateTime(): Long {

        val currentMillis = Date.now().toLong()
        return currentMillis
    }

    fun Long?.toStringDateTime():String {
        if (this == null) return ""

        val localDateTime = Instant.fromEpochMilliseconds(this)
            .toLocalDateTime(TimeZone.currentSystemDefault())

        val dateFormatOld = LocalDateTime.Format { //12/05/2024 18:14:24
            monthNumber(padding = Padding.SPACE)
            char('/')
            dayOfMonth()
            char('/')
            year()
            char(' ')
            hour()
            char(':')
            minute()
            char(':')
            second()
        }

        val dateFormat = LocalDateTime.Format { // December 05, 2024 06:25:14 PM
            monthName(MonthNames.ENGLISH_FULL)
            char(' ')
            dayOfMonth()
            char(',')
            char(' ')
            year()
            char(' ')
            amPmHour()
            char(':')
            minute()
            char(':')
            second()
            char(' ')
            chars(if (localDateTime.hour >= 12) "PM" else "AM")
        }


        return localDateTime.format(dateFormat).also {
            println(it)

        }


    }





}